import { useEffect, useRef } from 'react';
import { runTeamsAuthPopup } from '@/services/teamsAuthPopup';
import NotificationPage from './NotificationPage';

/** Page shown in the Teams sign-in popup while it hops to Microsoft login and back. */
export function TeamsAuthPopup() {
    const started = useRef(false);

    useEffect(() => {
        if (started.current) return;
        started.current = true;
        void runTeamsAuthPopup();
    }, []);

    return <NotificationPage content={<p>Signing in with Microsoft…</p>} enableRotation={true} />;
}
